// Advanced filter fields for the email audit trail. Each `key` is a
// tbl_email_audit_trail column, which the get-all API filters on directly.
// Every option is fixed, so the filter needs no dependencies loader.
export const emailAuditTrailFilterFields = [
  {
    key: "email_type",
    label: "Email Type",
    type: "enum",
    group: "Email",
    // Mirrors the EMAIL_TYPE enum.
    options: [
      { value: "AUTH", label: "Auth" },
      { value: "PROJECT_NOTIFICATION", label: "Project Notification" },
      { value: "CHAT_MESSAGE", label: "Chat Message" },
      { value: "REMINDER", label: "Reminder" },
      { value: "RESET_PASSWORD_OTP", label: "Reset Password OTP" },
      { value: "HELP", label: "Help" },
      { value: "OTHER", label: "Other" },
    ],
  },
  { key: "recipient_email", label: "Recipient", type: "string", group: "Email", placeholder: "Email contains…" },
  { key: "attempt", label: "Attempts", type: "int", group: "Email" },
  { key: "is_success", label: "Delivery Status", type: "boolean", group: "Delivery", trueLabel: "Success", falseLabel: "Failed" },
  { key: "is_read", label: "Read", type: "boolean", group: "Delivery", trueLabel: "Read", falseLabel: "Unread" },
  { key: "created_date", label: "Created At", type: "datetime", group: "Dates", showTime: true },
];
